import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ConfigService } from '../../../../core';
import {
  pessoaCentralCompras,
  pessoaFisica,
  pessoaJuridica
} from '../../../../home/pessoa/tipo/pessoa-tipo';
import { isModoCentralCompraCadastro } from '../../../../models/modo-central-compra';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-pessoa-tipo-multiselect',
  templateUrl: './novo-pessoa-tipo-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoPessoaTipoMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoPessoaTipoMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() tipos: number[];
  @Input() variante: 'filtro' | undefined;
  @Input() isShowPessoaFisica = true;
  @Input() isShowPessoaJuridica = true;
  @Input() isShowPessoaCentralCompras = true;

  @Input() settings: Partial<IMultiSelectSettings>;
  @Output() tiposChange = new EventEmitter<number[]>();

  options: IOption[] = [];

  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Nenhum Tipo',
    singular: 'Tipo',
    plural: 'Tipos',
    searchEmptyResultMessage: 'Nenhum tipo encontrado',
    showFooter: true
  };

  constructor(private configService: ConfigService) {
    super();
  }

  ngOnInit(): void {
    this.settings = {
      ...this.defaultSettings,
      ...this.settings
    };
    this.create();
  }

  private create(): void {
    const options: IOption[] = [];

    if (this.isShowPessoaFisica) {
      options.push({ id: pessoaFisica.id, label: pessoaFisica.nome });
    }
    if (this.isShowPessoaJuridica) {
      options.push({ id: pessoaJuridica.id, label: pessoaJuridica.nome });
    }
    if (
      this.isShowPessoaCentralCompras &&
      isModoCentralCompraCadastro(
        this.configService.getEmpresa()?.modoCentralCompra
      )
    ) {
      options.push({
        id: pessoaCentralCompras.id,
        label: pessoaCentralCompras.nome
      });
    }

    this.options = options;
  }

  onSelectionChange(): void {
    this.emitChange(this.tipos);
    this.markAsTouched();
  }

  onSearch(): void {
    this.tiposChange.emit(this.tipos);
  }

  protected updateValue(newValue: number[] | null): void {
    this.tipos = newValue ?? [];
  }
}
